module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/organisationmaster/organisationmaster.component.css
// module id = ./src/app/component/organisationmaster/organisationmaster.component.css
// module chunks = main